var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%"}},[_c('router-view'),_vm._v(" "),_c('vue-progress-bar'),_vm._v(" "),_c('notifications',{staticClass:"fizmix-notification",attrs:{"position":"top center","width":400}}),_vm._v(" "),_c('reveal')],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1cede7ce","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/App.vue
// module id = t+Pm
// module chunks = 0